import { render, staticRenderFns } from "./StartupListCard.vue?vue&type=template&id=9e39780e&scoped=true&"
import script from "./StartupListCard.vue?vue&type=script&lang=js&"
export * from "./StartupListCard.vue?vue&type=script&lang=js&"
import style0 from "./StartupListCard.vue?vue&type=style&index=0&id=9e39780e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e39780e",
  null
  
)

export default component.exports